import React from "react"
import { Provider } from "react-redux"
import createStore from "./src/state/createStore"

export default ({ element }) => {
     const store = createStore()

     return (
          <Provider store={store}>
               <>
                    {element}
                    <div id="consent_blackbar"></div>
                    
                    <div
                         id="teconsent"
                         data-consent="0,1,2"
                         role="complementary"
                         aria-label="Open Cookie Preferences Modal"
                         className="col-sm-12 footer-col text-center trustLink"
                    ></div>

               </>
          </Provider>
     )
}